import React from 'react'
import css from './style.scss'
import {FullPage} from 'components/container';



const Pro = (props)=>(
  <span className={css.pro}>PRO</span>
)

class FaqPage extends React.Component{
  render(){
    return (
      <FullPage withPadding withContainer>
        <div>
          <h1>Common Questions</h1>
          <div className={css.faq}>
            <div>
              <h2>Why you ask to connect with Facebook?</h2>
              <p>
                Connecting <b>Stori</b> to your Facebook accounts permits us to access also your Instagram Account.<br/>
                It's the only legal way to view your <b>Instagram Stories</b> without asking your Instagram password.<br/>
              </p>

              <h2>Do I need to be an Instagram Business Account to use Stori?</h2>
              <p>
                Though question:
                <ul>
                <li><b>No</b> if you only need to collaborate on another account.</li>
                <li><b>Yes</b> if you want to import and handle your Instagram Stories.</li>
                </ul>
                Unfortunately Instagram and Facebook doesn't permit us to access the Stories if you aren't a Business Account.<br/>
              </p>

              <h2>If I register today, can I see the data from my past stories?</h2>
              <p>No, we can't do that as we haven't access to Stories that are older than 24 hours.</p>

              <h2>What happens to the Stories on a <b>Free account</b> after 7 days?</h2>
              <p>We will continue to store them for 30 days, in this way if you upgrade you can also have all the data from the last month.<br/>
              After 30 days from the story creation date, Stori will delete them automatically.</p>

              <h2>Are my stories private?</h2>
              <p>Yes, nobody can see them unless you give explicity share them on Stori.</p>


              <h2>How can I share my stories and their data with somebody?</h2>
              <p>You have 3 ways:
                <ul>
                  <li>Create an adventure and share the public link with whoever you want: they will have access only to the stories and insights inside that adventure</li>
                  <li>Add somebody as a collaborator: they will have access to all your stories and insights <Pro/></li>
                  <li>Download all your stories and share them via an external service <Pro/></li>
                </ul>
              </p>

              <h2>What are adventures?</h2>
              <p>
                Adventures are collection of stories. You can add some stories (also from different days) and, if you want, share them with their special link.<br/>
                Adventures aren't public: only people with the link can access them, and you can always expire a link.<br/>
              </p>

              <h2>How do you handle payments?</h2>
              <p>
                We are using <b><a href="https://stripe.com/it" rel="noopener noreferrer" target="_blank">Stripe</a></b> and all connections are handled over HTTPS.
              </p>

              <h2>I have other questions.</h2>
              <p>
                We'd love to hear them. Contact us at <a rel="noopener noreferrer" target="_blank" href="mailto:hello@stori.social">hello@stori.social</a>.
              </p>


            </div>
          </div>
        </div>
      </FullPage>
    )
  }
}


export default FaqPage;



// WEBPACK FOOTER //
// ./src/components/faq/index.js